import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();

export const registrationState = atom<boolean>({
  key: 'registrationState',
  default: true,
  effects_UNSTABLE: [persistAtom],
});
